import {Nav} from "rsuite";

const styles = {
    marginBottom: '1rem',
};

const ReportingNav = ({ active, onSelect, ...props }) => {
    return (
        <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>
            <Nav.Item eventKey="basic">Basic</Nav.Item>
            <Nav.Item eventKey="explore">Explore</Nav.Item>
            <Nav.Item eventKey="discover">Discover</Nav.Item>
        </Nav>
    );
};

export default ReportingNav;